if (process.env.NODE_ENV === "production") {
  const marca_environment = "NO_TOCAR_MARCA_ENVIRONMENT";
  if (marca_environment === "PRODUCTION") {
    window.console.log = function () { };
  }
}

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import "./registerServiceWorker";

import store from "./store/store.js";
import "./util/FontAwesomeIcons";
import "./util/Filters";

Vue.config.productionTip = false;

import "css-ripple-effect/dist/ripple.min.css";
import "./tarjetas.css";

import Login from "./components/Paginas/Login.vue";
Vue.component("Login", Login);
import Inicio from "./components/Paginas/Inicio.vue";
Vue.component("Inicio", Inicio);
import PolizaAutos from "./components/Paginas/PolizaAutos.vue";
Vue.component("PolizaAutos", PolizaAutos);
import Cabecera from "./components/Cabecera.vue";
Vue.component("Cabecera", Cabecera);
import SaludoCliente from "./components/SaludoCliente.vue";
Vue.component("SaludoCliente", SaludoCliente);
import Vehiculo from "./components/Poliza/Vehiculo.vue";
Vue.component("Vehiculo", Vehiculo);
import Tomador from "./components/Poliza/Tomador.vue";
Vue.component("Tomador", Tomador);
import Contrato from "./components/Poliza/Contrato.vue";
Vue.component("Contrato", Contrato);
import EnlaceMenu from "./components/Menus/EnlaceMenu.vue";
Vue.component("EnlaceMenu", EnlaceMenu);

import ContratoSalud from "./components/Poliza/ContratoSalud.vue";
Vue.component("ContratoSalud", ContratoSalud);
import DatosBancariosSalud from "./components/Poliza/DatosBancariosSalud.vue";
Vue.component("DatosBancariosSalud", DatosBancariosSalud);

import EnlaceMenuSimple from "./components/Menus/EnlaceMenuSimple.vue";
Vue.component("EnlaceMenuSimple", EnlaceMenuSimple);

import EnlaceMenuSimpleResaltado from "./components/Menus/EnlaceMenuSimpleResaltado.vue";
Vue.component("EnlaceMenuSimpleResaltado", EnlaceMenuSimpleResaltado);

import Pie from "./components/Pie.vue";
Vue.component("Pie", Pie);
import Propietario from "./components/Poliza/Propietario.vue";
Vue.component("Propietario", Propietario);
import Conductor from "./components/Poliza/Conductor.vue";
Vue.component("Conductor", Conductor);
import DatosBancarios from "./components/Poliza/DatosBancarios.vue";
Vue.component("DatosBancarios", DatosBancarios);
import Vivienda from "./components/Poliza/Vivienda.vue";
Vue.component("Vivienda", Vivienda);
import CaracteristicasVivienda from "./components/Poliza/CaracteristicasVivienda.vue";
Vue.component("CaracteristicasVivienda", CaracteristicasVivienda);
import Capitales from "./components/Poliza/Capitales.vue";
Vue.component("Capitales", Capitales);
import DatosGenerales from "./components/Siniestro/DatosGenerales.vue";
Vue.component("DatosGenerales", DatosGenerales);
import SiniestroAutos from "./components/Paginas/SiniestroAutos.vue";
Vue.component("SiniestroAutos", SiniestroAutos);
import SiniestroHogar from "./components/Paginas/SiniestroHogar.vue";
Vue.component("SiniestroHogar", SiniestroHogar);
import SiniestroMovilidad from "./components/Paginas/SiniestroMovilidad.vue";
Vue.component("SiniestroMovilidad", SiniestroMovilidad);
import SiniestroNegocio from "./components/Paginas/SiniestroNegocio.vue";
Vue.component("SiniestroNegocio", SiniestroNegocio);
import Contrario from "./components/Siniestro/Contrario.vue";
Vue.component("Contrario", Contrario);
import Encargo from "./components/Siniestro/Encargo.vue";
Vue.component("Encargo", Encargo);
import Historial from "./components/Siniestro/Historial.vue";
Vue.component("Historial", Historial);

import Recibo from "./components/Paginas/Recibo.vue";
Vue.component("Recibo", Recibo);
import DatosRecibo from "./components/Recibo/DatosRecibo.vue";
Vue.component("DatosRecibo", DatosRecibo);
import DatosReciboInternauto from "./components/Recibo/DatosReciboInternauto.vue";
Vue.component("DatosReciboInternauto", DatosReciboInternauto);

import Campo2L from "./components/Campo2L.vue";
Vue.component("Campo2L", Campo2L);
import CampoPhone from "./components/CampoPhone.vue";
Vue.component("CampoPhone", CampoPhone);
import CampoEmail from "./components/CampoEmail.vue";
Vue.component("CampoEmail", CampoEmail);

import CampoSwitch from "./components/Switch.vue";
Vue.component("CampoSwitch", CampoSwitch);


import MenuLateralSeccion from "./components/MenuLateralSeccion.vue";
Vue.component("MenuLateralSeccion", MenuLateralSeccion);
import TemplateConMenuLateral from "./components/TemplateConMenuLateral.vue";
Vue.component("TemplateConMenuLateral", TemplateConMenuLateral);

import CampoVacio from "./components/CampoVacio.vue";
Vue.component("CampoVacio", CampoVacio);
import LinkAccion from "./components/LinkAccion.vue";
Vue.component("LinkAccion", LinkAccion);

import TarjetaDatos from "./components/TarjetaDatos.vue";
Vue.component("TarjetaDatos", TarjetaDatos);
import MenuInicio from "./components/Menus/MenuInicio.vue";
Vue.component("MenuInicio", MenuInicio);

import Alerta from "./components/Alerta.vue";
Vue.component("Alerta", Alerta);
import Spinner from "./components/Spinner.vue";
Vue.component("Spinner", Spinner);

import Banner from "./components/Banner.vue";
Vue.component("Banner", Banner);

import Instrucciones from "./components/Instrucciones.vue";
Vue.component("Instrucciones", Instrucciones);

import AsistenciaAuto from "./components/Secciones/Servicios/AsistenciaAuto.vue";
Vue.component("AsistenciaAuto", AsistenciaAuto);

import AsistenciaHogar from "./components/Secciones/Servicios/AsistenciaHogar.vue";
Vue.component("AsistenciaHogar", AsistenciaHogar);

import OficinaReferencia from "./components/Secciones/MiOficina/OficinaReferencia.vue";
Vue.component("OficinaReferencia", OficinaReferencia);

import AtencionClienteMediado from "./components/Secciones/AtencionClienteMediado.vue";
Vue.component("AtencionClienteMediado", AtencionClienteMediado);

import DeclararSiniestro from "./components/Secciones/Servicios/DeclararSiniestro.vue";
Vue.component("DeclararSiniestro", DeclararSiniestro);

import AsesoramientoJuridico from "./components/Secciones/Servicios/AsesoramientoJuridico.vue";
Vue.component("AsesoramientoJuridico", AsesoramientoJuridico);

import TeLlamamosConfirmTel from "./components/Secciones/TeLlamamosConfirmTel.vue";
Vue.component("TeLlamamosConfirmTel", TeLlamamosConfirmTel);

import NoMasEnviosPostales from "./components/NoMasEnviosPostales.vue";
Vue.component("NoMasEnviosPostales", NoMasEnviosPostales);
import NoMasEnviosPostales2 from "./components/NoMasEnviosPostales2.vue";
Vue.component("NoMasEnviosPostales2", NoMasEnviosPostales2);

import SeccionOcultable from "./components/SeccionOcultable.vue";
Vue.component("SeccionOcultable", SeccionOcultable);

import SiguenosEn from "./components/SiguenosEn.vue";
Vue.component("SiguenosEn", SiguenosEn);

import Loading from "./components/Loading.vue";
Vue.component("Loading", Loading);

import Cliente from "./components/Paginas/Cliente.vue";
Vue.component("Cliente", Cliente);

import DatosCliente from "./components/Cliente/DatosCliente.vue";
Vue.component("DatosCliente", DatosCliente);

import BotonAtras from "./components/BotonAtras.vue";
Vue.component("BotonAtras", BotonAtras);

import PopupTemplate from "./components/PopupTemplate.vue";
Vue.component("PopupTemplate", PopupTemplate);


import PanelMensajes from "./components/PanelMensajes.vue";
Vue.component("PanelMensajes", PanelMensajes);

import CabeceraLogin from "./components/CabeceraLogin.vue";
Vue.component("CabeceraLogin", CabeceraLogin);

import TemplateRegistro from "./components/Paginas/Registro/TemplateRegistro.vue";
Vue.component("TemplateRegistro", TemplateRegistro);

import Gdpr from "./components/Paginas/Registro/Gdpr.vue";
Vue.component("Gdpr", Gdpr);

import GdprTacito from "./components/Paginas/Registro/GdprTacito.vue";
Vue.component("GdprTacito", GdprTacito);

import CambiarTelefono from "./components/Cliente/CambiarTelefono.vue";
Vue.component("CambiarTelefono", CambiarTelefono);

import CambiarEmail from "./components/Cliente/CambiarEmail.vue";
Vue.component("CambiarEmail", CambiarEmail);

import NuevoEmail from "./components/Cliente/NuevoEmail.vue";
Vue.component("NuevoEmail", NuevoEmail);

import NuevoTelefono from "./components/Cliente/NuevoTelefono.vue";
Vue.component("NuevoTelefono", NuevoTelefono);

import SeleccionPolizas from "./components/Cliente/SeleccionPolizas.vue";
Vue.component("SeleccionPolizas", SeleccionPolizas);

import ResultadoCambio from "./components/Cliente/ResultadoCambio.vue";
Vue.component("ResultadoCambio", ResultadoCambio);

import EnlaceRecibo from "./components/EnlaceRecibo.vue";
Vue.component("EnlaceRecibo", EnlaceRecibo);

import CambiarPassword from "./components/Cliente/CambiarPassword.vue";
Vue.component("CambiarPassword", CambiarPassword);

import TemplateCambios from "./components/Cliente/TemplateCambios.vue";
Vue.component("TemplateCambios", TemplateCambios);

import AceptoCorreoVerde from "./components/Cliente/AceptoCorreoVerde.vue";
Vue.component("AceptoCorreoVerde", AceptoCorreoVerde);

import CambiarGdpr from "./components/Cliente/CambiarGdpr.vue";
Vue.component("CambiarGdpr", CambiarGdpr);

import AnadirAPaginaInicioIOS from "./components/AnadirAPaginaInicioIOS.vue";
Vue.component("AnadirAPaginaInicioIOS", AnadirAPaginaInicioIOS);

import SubsidioParalizacion from "./components/Secciones/Servicios/SubsidioParalizacion.vue";
Vue.component("SubsidioParalizacion", SubsidioParalizacion);

import TraeUnAmigo from "./components/Secciones/Ofertas/TraeUnAmigo/TraeUnAmigo.vue";
Vue.component("TraeUnAmigo", TraeUnAmigo);

import CuponAmigo from "./components/Secciones/Ofertas/TraeUnAmigo/CuponAmigo.vue";
Vue.component("CuponAmigo", CuponAmigo);

import InfoCuponAmigoPendiente from "./components/Secciones/Ofertas/TraeUnAmigo/InfoCuponAmigoPendiente.vue";
Vue.component("InfoCuponAmigoPendiente", InfoCuponAmigoPendiente);

import InfoCuponAmigoActivado from "./components/Secciones/Ofertas/TraeUnAmigo/InfoCuponAmigoActivado.vue";
Vue.component("InfoCuponAmigoActivado", InfoCuponAmigoActivado);

import InfoCuponAmigoDisponible from "./components/Secciones/Ofertas/TraeUnAmigo/InfoCuponAmigoDisponible.vue";
Vue.component("InfoCuponAmigoDisponible", InfoCuponAmigoDisponible);

import InfoCuponAmigoAsignado from "./components/Secciones/Ofertas/TraeUnAmigo/InfoCuponAmigoAsignado.vue";
Vue.component("InfoCuponAmigoAsignado", InfoCuponAmigoAsignado);

import InfoCuponAmigoConsumido from "./components/Secciones/Ofertas/TraeUnAmigo/InfoCuponAmigoConsumido.vue";
Vue.component("InfoCuponAmigoConsumido", InfoCuponAmigoConsumido);

import PolizaAsignableCuponAmigo from "./components/Secciones/Ofertas/TraeUnAmigo/PolizaAsignableCuponAmigo.vue";
Vue.component("PolizaAsignableCuponAmigo", PolizaAsignableCuponAmigo);

import TallerCRM from "./components/Secciones/Servicios/TallerCRM.vue";
Vue.component("TallerCRM", TallerCRM);

import TallerCRMBeneficios from "./components/Secciones/Beneficios/TallerCRMBeneficios.vue";
Vue.component("TallerCRMBeneficios", TallerCRMBeneficios);

import TalleresCalidadPremiumBeneficios from "./components/Secciones/Beneficios/TalleresCalidadPremiumBeneficios.vue";
Vue.component("TalleresCalidadPremiumBeneficios", TalleresCalidadPremiumBeneficios);


import ClubBeneficios from "./components/Secciones/Beneficios/ClubBeneficios.vue";
Vue.component("ClubBeneficios", ClubBeneficios);

import TalleresCalidadPremium from "./components/Secciones/Servicios/TalleresCalidadPremium.vue";
Vue.component("TalleresCalidadPremium", TalleresCalidadPremium);

import SeguroSaludHNAServicios from "./components/Secciones/Servicios/SeguroSaludHNAServicios.vue";
Vue.component("SeguroSaludHNAServicios", SeguroSaludHNAServicios);


import AhorraConTuTaxi from "./components/Secciones/Ofertas/AhorraConTuTaxi.vue";
Vue.component("AhorraConTuTaxi", AhorraConTuTaxi);

import SorteoParticipacionOK from "./components/Secciones/Sorteos/SorteoParticipacionOK.vue";
Vue.component("SorteoParticipacionOK", SorteoParticipacionOK);

import SorteoParticipacionNOK from "./components/Secciones/Sorteos/SorteoParticipacionNOK.vue";
Vue.component("SorteoParticipacionNOK", SorteoParticipacionNOK);

import PolizaDecesos from "./components/Paginas/PolizaDecesos.vue";
Vue.component("PolizaDecesos", PolizaDecesos);

import PolizaSalud from "./components/Paginas/PolizaSalud.vue";
Vue.component("PolizaSalud", PolizaSalud);

import PolizaSaludMMT from "./components/Paginas/PolizaSaludMMT.vue";
Vue.component("PolizaSaludMMT", PolizaSaludMMT);

import Asegurados from "./components/Poliza/Asegurados.vue";
Vue.component("Asegurados", Asegurados);

import ServiciosDecesosPremium from "./components/Secciones/Servicios/ServiciosDecesosPremium.vue";
Vue.component("ServiciosDecesosPremium", ServiciosDecesosPremium);

import Hogar90 from './components/Secciones/Ofertas/Hogar90.vue';
Vue.component("Hogar90", Hogar90);

import SeguroCoche from './components/Secciones/Ofertas/SeguroCoche.vue';
Vue.component("SeguroCoche", SeguroCoche);

import SeguroHogar from './components/Secciones/Ofertas/SeguroHogar.vue';
Vue.component("SeguroHogar", SeguroHogar);

import SeguroDecesos from './components/Secciones/Ofertas/SeguroDecesos.vue';
Vue.component("SeguroDecesos", SeguroDecesos);

import PromocionSorteoFreidora from './components/Secciones/Ofertas/PromocionSorteoFreidora.vue';
Vue.component("PromocionSorteoFreidora", PromocionSorteoFreidora);

import PromocionRegaloAspirador from './components/Secciones/Ofertas/PromocionRegaloAspirador.vue';
Vue.component("PromocionRegaloAspirador", PromocionRegaloAspirador);

import SeguroSalud from './components/Secciones/Ofertas/SeguroSalud.vue';
Vue.component("SeguroSalud", SeguroSalud);

import SeguroMovilidadVMP from './components/Secciones/Ofertas/SeguroMovilidadVMP.vue';
Vue.component("SeguroMovilidadVMP", SeguroMovilidadVMP);

import SeguroMoto from './components/Secciones/Ofertas/SeguroMoto';
Vue.component("SeguroMoto", SeguroMoto);

import SeguroAccidentes from './components/Secciones/Ofertas/SeguroAccidentes';
Vue.component("SeguroAccidentes", SeguroAccidentes);

import SeguroMascotas from './components/Secciones/Ofertas/SeguroMascotas';
Vue.component("SeguroMascotas", SeguroMascotas);

import SeguroNegocios from './components/Secciones/Ofertas/SeguroNegocios';
Vue.component("SeguroNegocios", SeguroNegocios);

import SeguroMovilidadPersonal from './components/Secciones/Ofertas/SeguroMovilidadPersonal.vue';
Vue.component("SeguroMovilidadPersonal", SeguroMovilidadPersonal);

import AvisoRenovacion from "./components/Paginas/AvisoRenovacion.vue";
Vue.component("AvisoRenovacion", AvisoRenovacion);

import DatosAvisoRenovacion from "./components/DatosAvisoRenovacion.vue";
Vue.component("DatosAvisoRenovacion", DatosAvisoRenovacion);

import SorteoFreidora from "./components/Secciones/Sorteos/SorteoFreidora.vue";
Vue.component("SorteoFreidora", SorteoFreidora);

import SorteoFreidoraFinPromocion from "./components/Secciones/Sorteos/SorteoFreidoraFinPromocion.vue";
Vue.component("SorteoFreidoraFinPromocion", SorteoFreidoraFinPromocion);

import CienEurosViajarSorteo from "./components/Secciones/CienEurosViajarSorteo.vue";
Vue.component("CienEurosViajarSorteo", CienEurosViajarSorteo);

import VehiculoVPM from "./components/Poliza/VehiculoVPM.vue";
Vue.component("VehiculoVPM", VehiculoVPM);

import ConductorMovilidad from "@/components/Poliza/ConductorMovilidad.vue";
Vue.component("ConductorMovilidad", ConductorMovilidad);

import CapitalesLocal from "@/components/Poliza/CapitalesLocal.vue";
Vue.component("CapitalesLocal", CapitalesLocal);

import Local from "@/components/Poliza/Local.vue";
Vue.component("Local", Local);

import MedidasProteccion from "@/components/Poliza/MedidasProteccion.vue";
Vue.component("MedidasProteccion", MedidasProteccion);


import Negocio from "@/components/Poliza/Negocio.vue";
Vue.component("Negocio", Negocio);

import PolizaNegocio from "@/components/Paginas/PolizaNegocio.vue";
Vue.component("PolizaNegocio", PolizaNegocio);

import Carglass from "@/components/Secciones/Servicios/Carglass.vue";
Vue.component("Carglass", Carglass);

import Animal from "@/components/Poliza/Animal.vue";
Vue.component("Animal", Animal);

import Cesur from "@/components/Secciones/Beneficios/Cesur.vue";
Vue.component("Cesur", Cesur);

import PromocionSalud1MesGratis from "@/components/Secciones/Ofertas/PromocionSalud1MesGratis.vue";
Vue.component("PromocionSalud1MesGratis", PromocionSalud1MesGratis);

import PromocionSaludSeVital from "@/components/Secciones/Ofertas/PromocionSaludSeVital.vue";
Vue.component("PromocionSaludSeVital", PromocionSaludSeVital);

import PromocionBlackFriday2025 from "@/components/Secciones/Ofertas/PromocionBlackFriday2025.vue";
Vue.component("PromocionBlackFriday2025", PromocionBlackFriday2025);

import PromocionMesMMTFebrero2026 from "@/components/Secciones/Ofertas/PromocionMesMMTFebrero2026.vue";
Vue.component("PromocionMesMMTFebrero2026", PromocionMesMMTFebrero2026);

import NuevoReglamentoCirculacion from "@/components/Secciones/Informacion/NuevoReglamentoCirculacion.vue";
Vue.component("NuevoReglamentoCirculacion", NuevoReglamentoCirculacion);


import router from "./router";

import Purecss from "purecss";

import eventBus from "@/util/EventBus.js";
Vue.prototype.$eventBus = eventBus;

import "@/util/NullSafeGet.js";

import Clipboard from "v-clipboard";

Vue.use(Clipboard);

import Toasted from "vue-toasted";

Vue.use(Toasted);

// new Vue({
//   render: h => h(App),
// }).$mount('#app')

/* eslint-disable */

new Vue({
  el: "#app",
  router,
  store,
  components: {
    App,
    Purecss
  },
  render: (h) => h(App)
});
